import { Navigate } from '@tanstack/react-router';
import { requireWorkspaceId } from '@/services/db/shared/workspace';
import { withoutDefaults, type ApiTriggeredSearch, type NewslettersSearch } from '../url-state';
import { BROADCASTS_TAB_ROUTES, type BroadcastsTab } from '../tabs';

type StaleGoalsRedirectProps = {
  tab: BroadcastsTab;
  search: NewslettersSearch | ApiTriggeredSearch;
};

/**
 * Takes goal ids back out of the URL while the account has no Goals filter. The list already
 * ignores them, but left in the URL they would come back the moment the filter did, and a
 * shared link would carry a filter nobody can see.
 */
export function StaleGoalsRedirect({ tab, search }: StaleGoalsRedirectProps) {
  return (
    <Navigate
      to={BROADCASTS_TAB_ROUTES[tab]}
      params={{ workspaceId: String(requireWorkspaceId()) }}
      search={withoutDefaults({ ...search, goalIds: undefined })}
      replace
    />
  );
}
